import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a5118772cc2500014e2f1c2_1783774054820_e35bd0ee/halalcham/src/app/dashboard/investor/page.tsx");
